import { alpha, makeStyles, Theme } from '@material-ui/core/styles';
import {
    LAUNCHER_SIZE_PX,
    WIDGET_EDGE_OFFSET_PX,
} from 'src/modules/assistant/constants/widget';

const GLOW_SOFT_ALPHA = 0.25;
const GLOW_STRONG_ALPHA = 0.45;

export const useWidgetStyles = makeStyles((theme: Theme) => ({
    '@keyframes assistantBorderGlow': {
        '0%, 100%': {
            borderColor: theme.palette.primary.main,
            boxShadow: `0 0 0 1px ${alpha(
                theme.palette.primary.main,
                GLOW_SOFT_ALPHA
            )}, 0 0 12px ${alpha(
                theme.palette.primary.light,
                GLOW_STRONG_ALPHA
            )}, ${theme.shadows[4]}`,
        },
        '50%': {
            borderColor: theme.palette.secondary.main,
            boxShadow: `0 0 0 2px ${alpha(
                theme.palette.secondary.main,
                GLOW_STRONG_ALPHA
            )}, 0 0 30px ${alpha(
                theme.palette.secondary.main,
                GLOW_STRONG_ALPHA
            )}, ${theme.shadows[6]}`,
        },
    },
    shell: {
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: LAUNCHER_SIZE_PX / 2,
        bottom: WIDGET_EDGE_OFFSET_PX,
        boxShadow: theme.shadows[6],
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        fontFamily: theme.typography.fontFamily,
        height: LAUNCHER_SIZE_PX,
        maxHeight: 'calc(100vh - 56px)',
        maxWidth: 'calc(100vw - 32px)',
        overflow: 'hidden',
        position: 'fixed',
        right: WIDGET_EDGE_OFFSET_PX,
        transition:
            'width 280ms ease, height 300ms ease, border-radius 280ms ease, box-shadow 280ms ease',
        width: LAUNCHER_SIZE_PX,
        zIndex: theme.zIndex.drawer + 1,
        [theme.breakpoints.down('xs')]: {
            bottom: 18,
            maxHeight: 'calc(100dvh - 36px)',
            right: 16,
        },
        '@media (prefers-reduced-motion: reduce)': {
            transition: 'none',
        },
    },
    shellOpen: {
        borderRadius: 20,
        boxShadow: theme.shadows[12],
        height: 760,
        width: 560,
        [theme.breakpoints.down('xs')]: {
            width: 'calc(100vw - 32px)',
        },
    },
    shellBusy: {
        animation: '$assistantBorderGlow 1.35s ease-in-out infinite',
        borderWidth: 2,
        '@media (prefers-reduced-motion: reduce)': {
            animation: 'none',
            borderColor: theme.palette.secondary.main,
            boxShadow: `0 0 0 2px ${alpha(
                theme.palette.secondary.main,
                GLOW_SOFT_ALPHA
            )}`,
        },
    },
    chat: {
        display: 'flex',
        flex: '1 1 auto',
        flexDirection: 'column',
        minHeight: 0,
    },
    transcript: {
        flex: '1 1 auto',
        minHeight: 0,
        overflowY: 'auto',
        padding: theme.spacing(2),
    },
}));
